import { AuthShell } from '../components/AuthShell'

/** Public privacy policy (Play Store / friends & family). */
export default function Privacy() {
  return (
    <AuthShell>
      <article className="space-y-6 text-sm leading-relaxed opacity-90">
        <header>
          <h1 className="text-2xl font-semibold opacity-100 mb-2">
            Privacy Policy
          </h1>
          <p className="opacity-60">Last updated: August 13, 2026</p>
        </header>

        <section className="space-y-0">
          <h2 className="text-lg font-medium opacity-100">The short version</h2>
          <p>
            Menu is a small, private app for friends and family to plan meals,
            share recipes, and coordinate shopping. We don&apos;t sell your data
            or show ads.
          </p>
        </section>

        <section className="space-y-0">
          <h2 className="text-lg font-medium opacity-100">What we collect</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              Account details (email, name) if you sign in — optional; you can
              also use the app without an account
            </li>
            <li>
              Content you create: recipes, meal plans, shopping lists, and
              household settings
            </li>
            <li>
              Optional Collect&amp;Go preferences if you connect that feature
            </li>
            <li>Basic technical logs needed to keep the service running</li>
          </ul>
        </section>

        <section className="space-y-0">
          <h2 className="text-lg font-medium opacity-100">How we use it</h2>
          <p>
            Only to run the app for you and the people in your household. We
            don&apos;t use your data for advertising or share it with third
            parties, except where needed to provide the service (e.g. sending
            login emails, or Google sign-in if you choose that).
          </p>
        </section>

        <section className="space-y-0">
          <h2 className="text-lg font-medium opacity-100">Who can see it</h2>
          <p>
            Your household members — the people you invite. This is not a public
            social network.
          </p>
        </section>

        <section className="space-y-0">
          <h2 className="text-lg font-medium opacity-100">
            Storage &amp; deletion
          </h2>
          <p>
            Data is stored on our server. You can delete your account and
            household data from Settings, or ask us to remove it.
          </p>
        </section>

        <section className="space-y-0">
          <h2 className="text-lg font-medium opacity-100">
            Third-party imagery
          </h2>
          <p>
            When a recipe has no photo of its own, we may fill in an image from{' '}
            <a
              href="https://www.themealdb.com/"
              className="underline underline-offset-2"
              target="_blank"
              rel="noreferrer"
            >
              TheMealDB
            </a>{' '}
            based on the recipe name (only when the name matches confidently).
            In the recipe editor we may also suggest stock photos from{' '}
            <a
              href="https://www.pexels.com"
              className="underline underline-offset-2"
              target="_blank"
              rel="noreferrer"
            >
              Pexels
            </a>
            ; those are stored only if you pick one, with photographer credit.
            Images from either source are stored on our server.
          </p>
        </section>

        <section className="space-y-0">
          <h2 className="text-lg font-medium opacity-100">Children</h2>
          <p>
            This app is intended for private use among people you know. It is
            not directed at children under 13.
          </p>
        </section>

        <section className="space-y-0">
          <h2 className="text-lg font-medium opacity-100">Changes</h2>
          <p>
            We may update this page occasionally. The date above reflects the
            latest version.
          </p>
        </section>

        <section className="space-y-0">
          <h2 className="text-lg font-medium opacity-100">Contact</h2>
          <p>
            Questions? Use the contact email on the Google Play listing, or
            reach out to whoever invited you to the app.
          </p>
        </section>
      </article>
    </AuthShell>
  )
}
